module.exports = __webpack_public_path__ + "static/media/large-thaiairways_and_wgs_20230201.a40002aa.png";